var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from 'react';
import cx from 'classnames';
import styles from './ProgressiveImage.css';
import placeholderImg from '../../../images/placeholder.svg';
import LazyLoad from '@utils/LazyLoadUtil';
import getImageUrl from '@utils/getImageUrl';
var ProgressiveImage = /** @class */ (function (_super) {
    __extends(ProgressiveImage, _super);
    function ProgressiveImage(props) {
        var _this = _super.call(this, props) || this;
        _this.onLoad = function () {
            _this.imageElement.onload = null;
            _this.imageElement.onerror = null;
            _this.imageElement.classList.add(styles['loaded']);
        };
        _this.callback = function () {
            _this.imageElement.src = _this.imageUrl;
            _this.id && LazyLoad.unregister(_this.id);
        };
        _this.onError = function () {
            window.requestAnimationFrame(function () {
                if (_this.imageElement) {
                    _this.imageElement.src = placeholderImg;
                }
            });
        };
        _this.quality = _this.props.quality || 80;
        _this.width = _this.props.width || 100;
        _this.height = _this.props.height || 100;
        _this.enableDPR = _this.props.enableDPR || false;
        return _this;
    }
    ProgressiveImage.prototype.componentDidMount = function () {
        this.id = LazyLoad.register(this.imageElement, this.callback);
    };
    ProgressiveImage.prototype.componentWillUnmount = function () {
        this.id && LazyLoad.unregister(this.id);
    };
    Object.defineProperty(ProgressiveImage.prototype, "imageUrl", {
        get: function () {
            var _a, _b, _c;
            var dynamicLink = typeof this.props.src === "string" ? getImageUrl(this.props.src, this.width, this.quality, this.height) : this.props.src;
            if (this.props.rukminiSrc) {
                var src = getImageUrl(this.props.rukminiSrc, this.width, this.height, this.quality, this.enableDPR);
                return src;
            }
            if (this.props.nocompression && this.props.src) {
                return dynamicLink;
            }
            var finalImgUrl = dynamicLink ? ((_c = (_a = dynamicLink) === null || _a === void 0 ? void 0 : (_b = _a).includes) === null || _c === void 0 ? void 0 : _c.call(_b, "?q")) ? dynamicLink : dynamicLink + "?q=" + this.quality : placeholderImg;
            return finalImgUrl;
        },
        enumerable: true,
        configurable: true
    });
    ProgressiveImage.prototype.render = function () {
        var _this = this;
        return (<img className={cx(styles['progressive-image'], this.props.className)} ref={function (img) { return (_this.imageElement = img); }} onClick={this.props.onClick} onError={this.onError} onLoad={this.onLoad}/>);
    };
    return ProgressiveImage;
}(PureComponent));
export default ProgressiveImage;
